import React, { useContext, useState } from "react"
import Text from "../../../_components/Text"
import AutoComplete from "../Financial/AutoComplete";
import VisualizePurchaseModal from "./modals/VisualizePurchaseModal";
import Row from "../../../_components/Layout/Row"
import TableData from "../../../_components/TableData"
import { getAllPurchases, putPurchase } from "../../../api/purchases"
import Button from "../../../_components/Button"
import { useEffect } from "react"
import { getSuppliers, } from "../../../api/products";
import LoadingInput from "../../../_components/LoadingInput";
import { formatDate, formateCurrentDate } from "../../../utils";
import Dropdown from "../../../_components/Dropdown";
import { formatCurrencyValue } from "../../../utils";
import { DropDownDivider, DropDownItem } from "../../../_components/Dropdown";
import Toast from "../../../_components/Toast";
import PurchaseContext from "./context";
export default function Purchases() {
    const [toast, setToast] = useState({
        show: false,
        message: '',
        color: ''
    });
    const pContext = useContext(PurchaseContext)
    const [purchase, setPurchase] = useState([]);
    const [currentItem, setCurrentItem] = useState({});
    const [status, setStatus] = useState({});
    const [createdDate, setCreatedDate] = useState('');
    const [ShowVisualizePurchaseModal, setVisualizePurchaseModal] = useState(false);
    const [loading, setLoading] = useState(false);
    
    async function getPurchases(params) {
        try {
            const data = await getAllPurchases(params);
            const formattedData = data.map(item => ({
                ...item,
                total_amount: formatCurrencyValue(item.total_amount),
                deadline: formatDate(item.deadline),
                created_date: formatDate(item.created_date),
                status: setStatusText(item),
                actions: (
                    <span>
                        <Dropdown data-cy-test={`#payin-ondrop-option-row=${item.status}`}>
                            {item.status !== 'Entregue' && (
                                <div>
                                    <DropDownItem>
                                        <Button
                                            as="text"
                                            className="text-info mx-1"
                                            data-cy-test={`#payin-action-icon-pay=${item.status}`}
                                            onClick={() => confirmPurchase(item)}
                                        >
                                            <i className="fas fa-money-bill-wave" />{" "}
                                            <span>Confirmar entrega</span>
                                        </Button>
                                    </DropDownItem>
                                    <DropDownDivider />
                                </div>
                            )}
                            <DropDownItem>
                                <Button
                                as="text"
                                className="text-dark mx-1"
                                onClick={() => {
                                setCurrentItem(item)
                                setVisualizePurchaseModal(true)}}>
                                    <i className="fa fa-eye" />{" "}
                                    <span>Visualizar compra</span>
                                </Button>
                            </DropDownItem>
                            <DropDownDivider />
                            <DropDownItem>
                                <Button as="text" className="text-danger mx-1">
                                    <i className="fa fa-times" />{" "}
                                    <span>Cancelar Compra</span>
                                </Button>
                            </DropDownItem>
                        </Dropdown>
                    </span>
                ),
            }));
            setPurchase(formattedData);
        } catch (error) {
            console.error('Failed to fetch purchases:', error);
        }
    }

    function setStatusText(item) {
        const statusType = {
            1: 'Pendente',
            2: 'Entregue',
            3: 'Cancelada',
            4: 'Atrasada',
        };
        if (item.deadline < formateCurrentDate() && item.status === 1) {
            return statusType[4];
        }
        return statusType[item.status];
    }

    async function getPurchaseStatus() {
        const statusType = {
            'Pendente': 0,
            'Entregue': 0,
            'Cancelada': 0,
            'Atrasada': 0,
        };
        for (const item of purchase) {
            statusType[item.status] += 1;
        }
        return statusType;
    }

    async function initScreen() {
        await getPurchases();
    }

    function confirmPurchase(item) {
        item.status = 2;
        putPurchase(item.id, item).then(resp => {
            setToast({
                show: true,
                message: "Compra confirmada com sucesso!"
            });
            setTimeout(() => {
                window.location.reload(false);
            }, 3000);
        }).catch(e => {
            console.error(e);
        });
    }

    function onChangeStatus(e) {
        const selectedStatus = e.target.value;
        getPurchases({ status: selectedStatus });
    }

    function onChangeCreatedDate(e) {
        setCreatedDate(e.target.value);
    }

    useEffect(() => {
        initScreen();
    }, []);

    useEffect(() => {
        const fetchStatus = async () => {
            const statusType = await getPurchaseStatus();
            setStatus(statusType);
        };
        fetchStatus();
    }, [purchase]);

    return (
        <div className="text-center">
            <Text fontSize="xlg" className='me-2 mt-4' color="sencondary">Compras</Text>
            <Row className='d-flex justify-content-between m-2'>
                <Button onClick={() => { window.location.href = '/purchases/create' }}>Criar compra</Button>
            </Row>
            <Row className="row justify-content-md-center">
                <div className="col-md-2 col-ms-12 p-2 bg-primary">
                    <Text color="sencondary" fontSize="md">Entregues</Text>
                    <Text color="sencondary" fontSize="lg">{status.Entregue || 0}</Text>
                </div>
                <div className="col-md-2 col-ms-12 p-2 bg-warning">
                    <Text color="sencondary" fontSize="md">Pendentes</Text>
                    <Text color="sencondary" fontSize="lg">{status.Pendente || 0}</Text>
                </div>
                <div className="col-md-2 col-ms-12 p-2 bg-danger">
                    <Text color="sencondary" fontSize="md">Atrasadas</Text>
                    <Text color="sencondary" fontSize="lg">{status.Atrasada|| 0}</Text>
                </div>
            </Row>


            <div>
                <Row className="d-flex m-2">
                
                <div className="col-lg-2 col-sm-12">
                    <LoadingInput className="mt-3" onChange={onChangeStatus} disabled={loading} name="status" as="select" defaultValue={""}>
                        <option value={""}>Status</option>
                        {["Pendente", "Entregue", "Atrasada"].map((value, _) => (
                            <option selected={value === status} key={`select_count_${_}`} value={value}>
                                {value}
                            </option>
                        ))}
                    </LoadingInput>
                </div>

                    <div className="col-lg-2 col-sm-12">
                        <LoadingInput className="mt-3" onChange={onChangeCreatedDate} disabled={loading} name="status" as="select" defaultValue={""}>
                            <option
                                value={""}>
                                Data de criação
                            </option>
                            {["Esse mês", "Essa semana", "Semana passada", "Mês passado"].map((value, _) => <option selected={value === status} key={`select_count_${_}`}
                                value={value} >{value}
                            </option>)}
                        </LoadingInput>
                    </div>
                    <div className="col-lg-2 col-sm-12 mt-3">
                        <AutoComplete
                            disabled={loading}
                            request={(...args) => getSuppliers(...args).then(result => {
                                return result.map(item => ({
                                    ...item,
                                    'sellable.name': item.name
                                }));
                            })}
                            searchField='sellable.name'
                            labelField='sellable.name'
                            valueField='id'
                            placeholder='Fornecedor'
                            onSelect={e => getPurchases({supplier: e.value})}
                        />
                    </div>
                </Row>

                <TableData
                    tHead={["Status", "Valor", "Data da compra", "Prazo de entrega", "Fornecedor", "Ações"]}
                    tBodyKeys={["status", "total_amount", "created_date", "deadline", "supplier_name", "actions"]}
                    data={purchase}
                />

                {
                    <Toast
                        message={toast.message}
                        show={toast.show}
                    />
                }

                {
                    <VisualizePurchaseModal
                        onShow={ShowVisualizePurchaseModal}
                        onHide={() => setVisualizePurchaseModal(false)}
                        item={currentItem}
                    />
                }
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Purchases/index.jsx